import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../../services/report.service';
import { Event, Router } from '@angular/router';
import { DailyCollectible } from '../../../models/reports/daily.collectible';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';

@Component({
	selector: 'app-collectibles',
	templateUrl: './collectibles.component.html',
	styleUrls: ['./collectibles.component.css']
})
export class CollectiblesComponent implements OnInit {

    dailyCollectible: DailyCollectible = new DailyCollectible();
    selectedDate: string;

	constructor(
        private _reportService: ReportService,
        private _router: Router
	) { }

	ngOnInit() {	
	}

	fetch(event: Event) {
        this.getDailyCollectible();
	}

	getDailyCollectible() {
		this._reportService.getDailyCollectible(this.selectedDate).subscribe(
			result => {
				if(result != undefined){
					this.dailyCollectible = result;
				}
			}
		);
    }
    
    goToClient(id: number){
		this._router.navigate([APP_ROUTES.clientForm.replace('/:id', ''), id]);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/reports/collectibles/collectibles.component.ts